// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { EMRDeviceCatalogType } from "../../types";
import { getEMRDeviceCatalog } from "../../api";

export const useEMRDeviceCatalog = (clinicId: string | undefined) => {
  const { getToken } = useTokenAccess();

  return useQuery<EMRDeviceCatalogType>({
    queryKey: ["emr-device-catalog", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      return getEMRDeviceCatalog(token, clinicId);
    },
    enabled: Boolean(clinicId),
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000,
  });
};
